// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2dk8E","emails":"CreateEditClinics_emails__1o2Xa","emailTagLabel":"CreateEditClinics_emailTagLabel__yX9_X"};